import { IncomingHttpHeaders } from 'http';

// Help from https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
// And https://megam.info/questions/41102060/typescript-extending-error-class
export class GfError extends Error {
	// tslint:disable-next-line: variable-name
	__proto__: Error | undefined;
	constructor(message?: string) {
		super(message);

		this.name = this.constructor.name;
	}
}

export class GfShouldNotHappenError extends GfError {}

export class GfUpstreamHttpError extends GfError {
	code: string | undefined;
	statusCode: number | undefined;
	headers: IncomingHttpHeaders | undefined;
	bodyStr: string | undefined;

	constructor(message: string) {
		super(message);
	}

	toString(): string {
		return `GfUpstreamHttpError: ${this.message}`;
	}
}

export class GfUpstreamHttpStatusCodeError extends GfError {
	readonly statusCode: number;
	readonly headers: IncomingHttpHeaders;
	readonly body: any;

	constructor(message: string, statusCode: number, headers: IncomingHttpHeaders, body: unknown) {
		super(message);
		this.statusCode = statusCode;
		this.headers = headers;
		this.body = body;
	}

	toString(): string {
		return `GfUpstreamHttpStatusCodeError: ${this.message}\nStatusCode: ${this.statusCode}\nHeaders: ${this.headers}Body:\n${this.body}`;
	}
}

export class GfCompositeError extends GfError {
	readonly causes: any[] | undefined;

	// Additional error properties?
	// https://nodejs.org/api/errors.html
	readonly address: string | undefined;
	readonly code: string | number | undefined;
	readonly dest: string | undefined;
	readonly errno: number | undefined;
	readonly info: any | undefined;
	readonly path: string | undefined;
	readonly port: number | undefined;
	readonly syscall: string | undefined;

	constructor(message: string, causes?: any[]) {
		super(message);

		if (causes && !Array.isArray(causes)) {
			causes = [causes];
		}

		this.causes = causes;

		// Append other error messages
		if (causes && causes.length > 0) {
			if (causes.length === 1) {
				this.message += `. Cause: [`;
			} else {
				this.message += `. Causes: [`;
			}
			this.message += causes.map(e => e.toString()).join('; ') + ']';
		}

		if (causes && causes.length > 0) {
			for (const cause of causes) {
				const subStack = cause && cause.stack;
				if (typeof subStack === 'string') {
					const lines = subStack.split('\n').map(s => '    ' + s);
					this.stack += `\n\n    Cause:\n\n${lines.join('\n')}`;
				} else {
					this.stack += `\n\n    Cause:\n\n${subStack}`;
				}

				// Forward SystemError properties?
				// https://nodejs.org/api/errors.html
				if (typeof cause.address === 'string') {
					this.address = cause.address;
				}
				if (typeof cause.code === 'string' || typeof cause.code === 'number') {
					this.code = cause.code;
				}
				if (typeof cause.dest === 'string') {
					this.dest = cause.dest;
				}
				if (typeof cause.errno === 'number') {
					this.errno = cause.errno;
				}
				if (typeof cause.info !== 'undefined') {
					this.info = cause.info;
				}
				if (typeof cause.path === 'string') {
					this.path = cause.path;
				}
				if (typeof cause.port === 'number') {
					this.port = cause.port;
				}
				if (typeof cause.syscall === 'string') {
					this.syscall = cause.syscall;
				}
			}
		}
	}
}
export const CompositeError = GfCompositeError;

export class GfCancellationError extends GfCompositeError {}

export class GfTimeoutError extends GfCompositeError {}
